<template>
  <div class="limited-width">
    <div v-if="customIndicator">
      <indicator-use-case
        :indicator-id="customIndicator.id"
        store-module="customIndicators"
        :indicator-name="customIndicator.name"
        :indicator-short-name="customIndicator.shortName"
        :indicator-color="indicatorColor"
        :benchmark-color="benchmarkColor"
        :events="events"
        :roles-for-full-access="rolesForFullAccess"
      />
    </div>
    <div v-else-if="allCustomIndicators !== null" class="vx-row mb-base">
      <div class="vx-col w-full">
        <vx-card refresh-by-default />
      </div>
    </div>
    <div v-else>
      <vx-card class="text-danger">{{ serverErrorMessage }}</vx-card>
    </div>
  </div>
</template>

<script>
import { hasAnyRole } from "@/acl";
import { Role } from "@/acl/roles";
import {
  EVENT_COVID19_CRISIS,
  EVENT_DECEMBER_2018_CRISIS,
  EVENT_EURO_CRISIS,
  EVENT_FINANCIAL_CRISIS,
} from "@/assets/constants/eventsDates";
import { PUBLIC_CUSTOM_INDICATORS, SERVER_ERROR_MESSAGE } from "@/assets/constants/global";
import exports from "@/assets/scss/exports.module.scss";
import IndicatorUseCase from "@/components/indicators/UseCase.vue";

export default {
  name: "CustomIndicatorUseCase",
  components: {
    IndicatorUseCase,
  },
  data() {
    return {
      serverErrorMessage: SERVER_ERROR_MESSAGE,
      customIndicator: null,
    };
  },
  computed: {
    isAuthenticated() {
      return hasAnyRole(Role.insight);
    },
    allCustomIndicators() {
      return this.$store.getters["customIndicators/getCustomIndicators"];
    },
    indicatorColor() {
      return exports["colors-primary"];
    },
    benchmarkColor() {
      return exports["colors-benchmark"];
    },
    events() {
      return [
        EVENT_FINANCIAL_CRISIS,
        EVENT_EURO_CRISIS,
        EVENT_DECEMBER_2018_CRISIS,
        EVENT_COVID19_CRISIS,
      ];
    },
    rolesForFullAccess() {
      if (this.customIndicator == null) {
        return null;
      }

      if (PUBLIC_CUSTOM_INDICATORS.includes(this.customIndicator["id"])) {
        return [Role.insight];
      }

      return [Role.indicator, Role.employee, Role.admin, Role.superAdmin];
    },
  },
  watch: {
    allCustomIndicators: {
      handler: function (newCustomIndicators) {
        // Only execute this if it was bound.
        if (this.customIndicator == null && newCustomIndicators != null) {
          this.customIndicator = newCustomIndicators.find(
            (customIndicator) => customIndicator.id === this.$route.params.customIndicatorId
          );

          // If the custom indicator couldn't be found:
          if (!this.customIndicator) {
            if (this.isAuthenticated) {
              // If we are logged in, then we redirect to 404.
              this.$router.push({ name: "page-error-404" });
            } else {
              // If we aren't logged in, it's normal that we don't
              // find any custom indicator, hence we redirect to login.
              this.$router.push({ name: "page-login" });
            }
          }
        }
      },
      immediate: true,
    },
  },
  metaInfo() {
    if (this.customIndicator) {
      return {
        title: `Custom Indicators - ${this.customIndicator.name}`,
      };
    } else {
      return {
        title: "Prisma - Custom Indicators",
      };
    }
  },
};
</script>
